

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation, State } from "vuex-class"

import TenantInfo from "@/types/tenantInfo"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import tenantApi from "@/services/api_Tenant"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar
	}
})
export default class TenantInfoDisplay extends Vue {
	/**
	 * @summary Allows tenant info to be set from parent. If not set, will be fetched on mount.
	 */
	@Prop({ default: () => null })
	tenantInfo!: TenantInfo[] | null

	loaded = false
	tenantInfoItems: TenantInfo[] = []

	async mounted () {
		this.tenantInfoItems = this.tenantInfo
			? this.tenantInfo
			: await tenantApi.tenantInfoGet()
		this.loaded = true
	}
}

